import { render } from "./uiTabFramework.vue?vue&type=template&id=81d868e4&scoped=true&ts=true&lang=pug"
import script from "./uiTabFramework.vue?vue&type=script&lang=ts"
export * from "./uiTabFramework.vue?vue&type=script&lang=ts"

import "./uiTabFramework.vue?vue&type=style&index=0&id=81d868e4&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81d868e4"]])

export default __exports__